exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ld-error {\n  border: 1px solid #B03060 !important;\n}\n\n:host >>> .avatar img {\n  height: auto;\n  width: 150px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./app/components/user-form/user-form.component.css
// module id = 868
// module chunks = 0